// commonRegister.js
import Cookies from "js-cookie";
import { login, logout, getInfo, getMenusRoutes, refreshToken } from "../api/system1/user";
import { getToken, setToken, removeToken, setRefreshToken, getRefreshToken, removeRefreshToken, removeTenantId } from "../utils/auth";
import { filterAsyncRouter } from "../utils/index";
import { getServerTime } from "../utils/setHeader";

import { constantRoutes } from "../router";
import { getCurrentTab } from "@/utils/storage";
//settings
import defaultSettings from "../utils/settings";
const { showSettings, tagsView, fixedHeader, sidebarLogo } = defaultSettings;
//settings---end

/**
 *
 * @param {vuex实例} store
 * @param {qiankun下发的props} props
 * @param {vue-router实例} router
 * @param {Function} resetRouter - 重置路由方法
 */

function registerCommonModule(
  store,
  props = {},
  router,
  resetRouter
) {
  // console.log('props', props)
  // console.log('store-***-', store)
  if (!store) {
    return;
  }
  // 深拷贝一份基础路由
  // 获取初始化的state
  // eslint-disable-next-line no-mixed-operators
  const initState = (props.store && props.store.state.common) || {
    token: getToken(),
    refreshtoken: getRefreshToken(),
    tokenStatus: true, //token 状态
    name: "",
    avatar: "",
    tenantId: window.localStorage.getItem("tenantId") || null, // 从本地存储恢复，刷新页面不丢失
    roles: [],
    visitedViews: [],
    userInfo: "",
    cachedViews: [],
    permissions: ["*:*:*"],
    dept: null,
    routes: [],
    addRoutes: [],
    menu: [],
    adminleftnavnum: "1", //左侧导航选中的菜单
    showSettings: showSettings,
    tagsView: tagsView,
    fixedHeader: fixedHeader,
    sidebarLogo: sidebarLogo,
    sidebar: {
      opened: Cookies.get("sidebarStatus")
        ? !!+Cookies.get("sidebarStatus")
        : true,
      withoutAnimation: false,
    },
    device: "desktop",
    size: Cookies.get("size") || "medium",
    serverTime: 0,
    serverTimeInterval: null,
    userInfo: "",
    app: "main", // 启用应用名，默认main(主应用)，区分各个应用下，如果运行的是pms，则是pms，用于判断路由
  };

  // 将父应用的数据存储到子应用中，命名空间固定为common

  const commonModule = {
    namespaced: true,
    state: initState,
    actions: {
      // 登录
      Login({ commit, dispatch }, userInfo) {
        const username = userInfo.username.trim();
        const password = userInfo.password;
        const code = userInfo.code;
        const uuid = userInfo.uuid;
        return new Promise((resolve, reject) => {
          // 清理可能存在的无效 tenantId
          const savedTenantId = window.localStorage.getItem("tenantId")
          if (savedTenantId === "null" || savedTenantId === "undefined" || savedTenantId === "NaN") {
            window.localStorage.removeItem("tenantId")
          }
          
          login(username, password, code, uuid)
            .then((res) => {
              setToken(res.token);
              setRefreshToken(res.refreshToken);
              localStorage.setItem("userId", uuid);
              commit("SET_TOKEN", res.token);
              commit("SET_REFRESH_TOKEN", res.refreshToken);

              resolve();
            })
            .catch((error) => {
              reject(error);
            });
        });
      },
      // token过期，刷新token
      refreshToken({ commit, state }) {
        return new Promise((resolve, reject) => {
          const currentRefreshToken = getRefreshToken();
          if (!currentRefreshToken) {
            reject(new Error("refresh token 不存在"));
            return;
          }

          refreshToken(currentRefreshToken)
            .then((res) => {
              setToken(res.data.tokenType + " " + res.data.accessToken);
              setRefreshToken(res.data.refreshToken);
              commit("SET_TOKEN", res.data.tokenType + " " + res.data.accessToken);
              commit("SET_REFRESH_TOKEN", res.data.refreshToken);
              commit("updateTokenStatus", true);
              resolve(res.data);
            })
            .catch((error) => {
              commit("SET_TOKEN", "");
              commit("SET_REFRESH_TOKEN", "");
              removeToken();
              removeRefreshToken();
              commit("updateTokenStatus", false);
              reject(error);
            });
        });
      },

      // 获取用户信息
      GetInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
          getInfo(state.token)
            .then((res) => {
              console.log(res, 444);
              if (res) {
                //   console.log('res', res)
                const user = res.data;
                if (res.data.roles && res.data.roles.length > 0) {
                  // 验证返回的roles是否是一个非空数组
                  commit("SET_ROLES", res.data.roles);
                  commit("SET_PERMISSIONS", res.data.perms);
                } else {
                  commit("SET_ROLES", ["ROLE_DEFAULT"]);
                }
                commit("SET_NAME", user.nickname);
                // commit("SET_DEPT", user.dept);
                // console.log("dept", user.dept);
                const existingTenantId = window.localStorage.getItem("tenantId")
                const hasValidTenantId = existingTenantId && existingTenantId !== "null" && existingTenantId !== "undefined"
                if (user.userType !=3 && user.tenantInfos && user?.tenantInfos.length > 0 && !hasValidTenantId) {
                  commit("CHANGE_TENANTID", user.tenantInfos[0].tenantId);//租户管理员，普通用户默认选第一个租户
                }
                commit("SET_AVATAR", res.data.avatar);
                commit("setUserInfo", user);
                resolve(res);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      },

      // 退出系统
      LogOut({ commit, state }) {
        return new Promise((resolve, reject) => {
          logout(state.token)
            .then(() => {
              commit("SET_TOKEN", "");
              commit("SET_REFRESH_TOKEN", "");
              commit("SET_NAME", "");
              commit("SET_DEPT", "");
              commit("SET_ROLES", []);
              commit("CLEAR_TENANTID"); // 使用专门的清理 mutation
              commit("SET_PERMISSIONS", []);
              removeToken();
              removeRefreshToken();
              commit("updateTokenStatus", false);
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
        });
      },
      LogOut1({ commit, state }) {
        return new Promise((resolve, reject) => {
          commit("SET_TOKEN", "");
          commit("SET_REFRESH_TOKEN", "");
          commit("SET_NAME", "");
          commit("SET_DEPT", "");
          commit("SET_ROLES", []);
          commit("CLEAR_TENANTID"); // 使用专门的清理 mutation
          commit("SET_PERMISSIONS", []);
          removeToken();
          removeRefreshToken();
          commit("updateTokenStatus", false);
          let title = window.g.VUE_APP_TITLE || "智能配网分析决策系统";
          const staticSettting = {
            appId: "xWIqqaOPHQqJ",
            appSecret: "2a06IArpGsVH9qLH8C1U1",
            authUrl: `${window.g.VUE_APP_AUTH_URL}`,
            // baseUrl: 'http://192.168.100.184:7878',
            baseUrl: `${window.g.VUE_APP_BASE_URL}`,
            grant_type: "authorization_code",
          };
          window.location.href =
            staticSettting.authUrl +
            "/oauth/authorize?response_type=code&client_id=" +
            staticSettting.appId +
            "&redirect_uri=" +
            staticSettting.baseUrl +
            "&title=" +
            title;
          resolve();
        });
      },
      getMenu({ commit }) {
        return new Promise((resolve) => {
          // 向后端请求路由数据
          getMenusRoutes().then((res) => {
            let router = res.data;
            let copyRoute = JSON.parse(JSON.stringify(router));
            commit("SET_ROUTES", router);
            if (router) {
              resolve(copyRoute);
            } else {
              resolve([]);
            }
          });
        });
        // return new Promise((resolve) => {
        // //   // 向后端请求路由数据
        // //   getRouters().then((res) => {
        // //     let router = res.data.router;
        //     // let copyRoute = JSON.parse(JSON.stringify(router));
        //     commit("SET_ROUTES",[]);
        // //     if (router) {
        // //       resolve(copyRoute);
        // //     } else {
        //       resolve([]);
        // //     }
        // //   });
        // });
      },

      // 前端 登出
      FedLogOut({ commit }) {
        return new Promise((resolve) => {
          commit("SET_TOKEN", "");
          commit("SET_REFRESH_TOKEN", "");
          removeToken();
          removeRefreshToken();
          resolve();
        });
      },
      setApp({ commit, dispatch }, appName) {
        commit("setApp", appName);
      },

      // app
      changeSetting({ commit }, data) {
        commit("CHANGE_SETTING", data);
      },
      changeTenantId({ commit }, data) {
        commit("CHANGE_TENANTID", data);
      },
      toggleSideBar({ commit }) {
        commit("TOGGLE_SIDEBAR");
      },
      closeSideBar({ commit }, { withoutAnimation }) {
        commit("CLOSE_SIDEBAR", withoutAnimation);
      },
      toggleDevice({ commit }, device) {
        commit("TOGGLE_DEVICE", device);
      },
      setSize({ commit }, size) {
        commit("SET_SIZE", size);
      },
      //app end

      //标签 tags 缓存
      addView({ dispatch, commit }, view) {
        dispatch("addVisitedView", view);
        dispatch("addCachedView", view);
      },
      addVisitedView({ commit }, view) {
        commit("ADD_VISITED_VIEW", view);
        // commit('emitGlobalState')
      },
      addCachedView({ commit }, view) {
        commit("ADD_CACHED_VIEW", view);
      },

      delView({ dispatch, state }, view) {
        return new Promise((resolve) => {
          dispatch("delVisitedView", view);
          dispatch("delCachedView", view);
          resolve({
            visitedViews: [...state.visitedViews],
            cachedViews: [...state.cachedViews],
          });
        });
      },
      delVisitedView({ commit, state }, view) {
        return new Promise((resolve) => {
          commit("DEL_VISITED_VIEW", view);
          resolve([...state.visitedViews]);
        });
      },
      delCachedView({ commit, state }, view) {
        return new Promise((resolve) => {
          commit("DEL_CACHED_VIEW", view);
          resolve([...state.cachedViews]);
        });
      },

      delOthersViews({ dispatch, state }, view) {
        return new Promise((resolve) => {
          dispatch("delOthersVisitedViews", view);
          dispatch("delOthersCachedViews", view);
          resolve({
            visitedViews: [...state.visitedViews],
            cachedViews: [...state.cachedViews],
          });
        });
      },
      delOthersVisitedViews({ commit, state }, view) {
        return new Promise((resolve) => {
          commit("DEL_OTHERS_VISITED_VIEWS", view);
          resolve([...state.visitedViews]);
        });
      },
      delOthersCachedViews({ commit, state }, view) {
        return new Promise((resolve) => {
          commit("DEL_OTHERS_CACHED_VIEWS", view);
          resolve([...state.cachedViews]);
        });
      },

      delAllViews({ dispatch, state }, view) {
        return new Promise((resolve) => {
          dispatch("delAllVisitedViews", view);
          dispatch("delAllCachedViews", view);
          resolve({
            visitedViews: [...state.visitedViews],
            cachedViews: [...state.cachedViews],
          });
        });
      },
      delAllVisitedViews({ commit, state }) {
        return new Promise((resolve) => {
          commit("DEL_ALL_VISITED_VIEWS");
          resolve([...state.visitedViews]);
        });
      },
      delAllCachedViews({ commit, state }) {
        return new Promise((resolve) => {
          commit("DEL_ALL_CACHED_VIEWS");
          resolve([...state.cachedViews]);
        });
      },

      updateVisitedView({ commit }, view) {
        commit("UPDATE_VISITED_VIEW", view);
      },
      getServerTime({ commit, state }) {
        return new Promise((resolve) => {
          getServerTime().then((res) => {
            if (res.code === 1000) {
              commit("UPDATE_SERVER_TIME", res.data);
              if (state.serverTimeInterval) {
                clearInterval(state.serverTimeInterval);
                state.serverTimeInterval = null;
              }
              state.serverTimeInterval = setInterval(() => {
                commit("UPDATE_SERVER_TIME");
              }, 1000);
              document.addEventListener("visibilitychange", function () {
                if (document.visibilityState === "hidden") {
                  if (state.serverTimeInterval) {
                    clearInterval(state.serverTimeInterval);
                    state.serverTimeInterval = null;
                  }
                } else {
                  getServerTime().then((res) => {
                    commit("UPDATE_SERVER_TIME", res.data);
                    if (state.serverTimeInterval) {
                      clearInterval(state.serverTimeInterval);
                      state.serverTimeInterval = null;
                    }
                    state.serverTimeInterval = setInterval(() => {
                      commit("UPDATE_SERVER_TIME");
                    }, 1000);
                  });
                }
              });
              resolve();
            }
          });
        });
      },
      //标签 end
    },
    mutations: {
      UPDATE_SERVER_TIME: (state, payload) => {
        if (payload) {
          state.serverTime = payload;
        } else {
          state.serverTime += 1;
        }
      },

      updateTokenStatus(state, bool) {
        state.tokenStatus = bool;
      },

      SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions;
      },
      SET_ROLES: (state, roles) => {
        state.roles = roles;
      },
      SET_ROUTES(state, payload) {
        let menu = JSON.parse(JSON.stringify(constantRoutes)).filter((item) => {
          if (item.path == '/') {
            return item
          }
        });
        let menu1 = menu[0].children.concat(payload);
        constantRoutes.filter((item) => {
          if (item.path == '/') {
            item.children = menu1
          }
        });

        state.routes = JSON.parse(JSON.stringify(constantRoutes));
        console.log('state.routes===', state.routes)
        // console.log(state.routes,'state.routes===')
        // // let copyRoute = JSON.parse(JSON.stringify(payload));
        // let copymenu1 = JSON.parse(JSON.stringify(menu1));
        state.menu = JSON.parse(JSON.stringify(constantRoutes));
      },
      SET_MENU(state, payload) {
        state.menu = payload;
      },

      setAuth(state, data) {
        state.auth = data || {};
        if (data) {
          setToken(data);
        } else {
          removeToken();
        }
      },
      setUserInfo(state, data) {
        state.userInfo = data;
      },

      setApp(state, appName) {
        state.common = appName;
      },
      SET_TOKEN: (state, token) => {
        state.token = token;
      },
      SET_REFRESH_TOKEN: (state, token) => {
        state.refreshtoken = token;
      },
      SET_NAME: (state, name) => {
        state.name = name;
        window.localStorage.setItem("name", name);
      },
      SET_AVATAR: (state, avatar) => {
        state.avatar = avatar;
      },

      SET_DEPT: (state, dept) => {
        state.dept = dept;
        window.localStorage.setItem("deptName", dept.deptName);
      },

      //
      CHANGE_SETTING: (state, { key, value }) => {
        if (state.hasOwnProperty(key)) {
          state[key] = value;
        }
      },
      CHANGE_TENANTID: (state, tenantId) => {
        state.tenantId = tenantId;
        window.localStorage.setItem("tenantId", tenantId);
        Cookies.set("tenantId", tenantId);
      },
      // 专门用于清理 tenantId 的 mutation，彻底清除所有存储
      CLEAR_TENANTID: (state) => {
        state.tenantId = null;
        window.localStorage.removeItem("tenantId");
        removeTenantId(); // 清除 Cookie
      },
      TOGGLE_SIDEBAR: (state) => {
        state.sidebar.opened = !state.sidebar.opened;
        state.sidebar.withoutAnimation = false;
        if (state.sidebar.opened) {
          Cookies.set("sidebarStatus", 1);
        } else {
          Cookies.set("sidebarStatus", 0);
        }
      },
      CLOSE_SIDEBAR: (state, withoutAnimation) => {
        Cookies.set("sidebarStatus", 0);
        state.sidebar.opened = false;
        state.sidebar.withoutAnimation = withoutAnimation;
      },
      TOGGLE_DEVICE: (state, device) => {
        state.device = device;
      },
      SET_SIZE: (state, size) => {
        state.size = size;
        Cookies.set("size", size);
      },
      //tags 标签缓存

      ADD_VISITED_VIEW: (state, view) => {
        console.log(view, "view=========");
        let hasView = state.visitedViews.find((v) => v.path === view.path);
        if (hasView) {
          // hasView.currentTab = getCurrentTab()
          return;
        }
        state.visitedViews.push(
          Object.assign(
            true,
            { currentTab: getCurrentTab() },
            { ...view },
            {
              title: view.meta.title || "no-name",
            }
          )
        );
      },

      ADD_CACHED_VIEW: (state, view) => {
        if (state.cachedViews.includes(view.name)) return;
        //三级路由
        if (view.matched.length === 3) {
          if (!state.cachedViews.includes(view.matched[1].name)) {
            state.cachedViews.push(view.matched[1].name);
          }
        }
        if (!view.meta.noCache) {
          state.cachedViews.push(view.name);
        }
      },

      DEL_VISITED_VIEW: (state, view) => {
        let visited = state.visitedViews;
        for (const [i, v] of state.visitedViews.entries()) {
          if (v.path === view.path) {
            visited.splice(i, 1);
            state.visitedViews = visited;

            break;
          }
        }
      },
      DEL_CACHED_VIEW: (state, view) => {
        console.log(view, "view----------");
        for (const i of state.cachedViews) {
          if (i === view.name) {
            const index = state.cachedViews.indexOf(i);
            state.cachedViews.splice(index, 1);
            break;
          }
        }
      },

      DEL_OTHERS_VISITED_VIEWS: (state, view) => {
        state.visitedViews = state.visitedViews.filter((v) => {
          return v.meta.affix || v.path === view.path;
        });
      },
      DEL_OTHERS_CACHED_VIEWS: (state, view) => {
        for (const i of state.cachedViews) {
          if (i === view.name) {
            const index = state.cachedViews.indexOf(i);
            state.cachedViews = state.cachedViews.slice(index, index + 1);
            break;
          }
        }
      },

      DEL_ALL_VISITED_VIEWS: (state) => {
        const affixTags = state.visitedViews.filter((tag) => tag.meta.affix);
        state.visitedViews = affixTags;
      },
      DEL_ALL_CACHED_VIEWS: (state) => {
        state.cachedViews = [];
      },

      UPDATE_VISITED_VIEW: (state, view) => {
        for (let v of state.visitedViews) {
          if (v.path === view.path) {
            v = Object.assign(v, view);
            break;
          }
        }
      },
      //设置换肤class
      setTheme(state) {
        if (state.theme === "1") {
          document.body.setAttribute("class", "darkBody");
        } else {
          document.body.setAttribute("class", "defaultBody");
        }
      },
    },
    getters: {
      visitedViews: (state) => state.visitedViews,
      cachedViews: (state) => state.cachedViews,
      sidebar: (state) => state.sidebar,
      avatar: (state) => state.avatar,
      device: (state) => state.device,
    },
  };

  store.registerModule("common", commonModule);
}

export default registerCommonModule;
